export default __webpack_public_path__ + "static/media/mule-deer.bf958a1d.webp";